namespace $.$$ {
	export class $shm_agent_app_sessions extends $.$shm_agent_app_sessions {
		drag_buttons( id: string ) { return this.locked() ? [] : [ 0 ] }
		drop_target( id: string, x: number, y: number ) {
			const target = super.drop_target( id, x, y )
			const base = this.base_nodes( id )
			const count = base.filter( node => this.pinned( node.id ) ).length
			target.index = this.pinned( id ) ? Math.min( target.index, count ) : Math.max( target.index, count )
			target.top = this.top_by_index( this.layout( base ), target.index )
			return target
		}
	}
}
